import { useEffect, useRef } from 'react'

interface NotificationSoundProps {
  play: boolean
  onEnded?: () => void
}

export function NotificationSound({ play, onEnded }: NotificationSoundProps) {
  const audioRef = useRef<HTMLAudioElement | null>(null)

  useEffect(() => {
    if (play && audioRef.current) {
      audioRef.current.currentTime = 0
      audioRef.current.play().catch(e => {
        console.log('Failed to play notification sound:', e)
      })
    }
  }, [play])

  return (
    <audio 
      ref={audioRef}
      src="/notification.mp3"
      onEnded={onEnded}
      style={{ display: 'none' }}
    />
  )
}